import { apiCreateTicket } from "../../utils/api";
import { validate, validateEmail } from "../../utils/validate";

import './style.scss';

let typeForm = "contact";

export const contactFormSetup = () => {
  $("#contact_form_extension").on("submit", function (e) {
    e.preventDefault();
    const apiTime = Date.now();
    window.apiTime = apiTime;
    if (validateForm()) {
      submitContactForm(apiTime);
    }
  });
}

export const validateForm = () => {
  let valName = validate({ selector: "#contact_form_extension .name input" });
  let valPhone = true;
  if (typeForm === "contact") {
    valPhone = validate({ selector: "#contact_form_extension .phone input", isFocus: valName })
  }
  let valEmail = validate({ selector: "#contact_form_extension .email input", validator: validateEmail, isFocus: valName && valPhone });
  return valName && valEmail && valPhone;
}

export const submitContactForm = (apiTime) => {
  apiCreateTicket(
    getParamsTicket(),
    function (data) {
      $("#contact_form_extension .message").show();
      setTimeout(function () {
        $("#contact_form_extension .message").hide();
      }, 3000);
      resetFormContact();
    }, function (error) {
      $("#contact_form_extension .message").show();
      resetFormContact();
    }, apiTime);
}

function getParamsTicket() {
  let params = {
    ticket_type: typeForm,
    meta: {
      name: $('#contact_form_extension .name input').val(),
      email: $('#contact_form_extension .email input').val(),
      phone: $('#contact_form_extension .phone input').val(),
      message: $('#contact_form_extension .feedback textarea').val(),
    }
  }
  return params;
}

export const resetFormContact = () => {
  $('#contact_form_extension .name input').val("").trigger("change");
  $('#contact_form_extension .email input').val("").trigger("change");
  $('#contact_form_extension .phone input').val("").trigger("change");
  $('#contact_form_extension .feedback textarea').val("").trigger("change");
}

export const setUpContactForm = (type) => {
  if (type) {
    typeForm = type;
  }
  contactFormSetup();
}